export const RETRY_CONTACT_ADMIN = 'กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'

export const ERR_MSG = `เกิดข้อผิดพลาด`

export const SEARCH = `ค้นหา`

export const SAVE = `บันทึก`
export const CANCEL = `ยกเลิก`
export const ADD = `เพิ่ม`
export const EDIT = `แก้ไข`
export const DELETE = `ลบ`

export const SAVE_EDIT = `บันทึกแก้ไข`
export const ADD_EDIT = `เพิ่ม/แก้ไข`

export const NOT_COMPLETE = `ไม่สำเร็จ`

export const VIEW_LIST = `ดูรายการ`

export const CONFIRM_MSG = `ยืนยัน`
export const SUCCESS_MSG = `สำเร็จ`

export const PLEASE_CONFIRM_MSG = `กรุณา${CONFIRM_MSG}`

export const SAVE_ERR_MSG = `${ERR_MSG}ในการบันทึก ${RETRY_CONTACT_ADMIN}`

export const SEARCH_ERR_MSG = `${ERR_MSG}ในการค้นหา ${RETRY_CONTACT_ADMIN}`

export const DELETE_ERR_MSG = `${ERR_MSG}ในการลบ ${RETRY_CONTACT_ADMIN}`

export const DEFAULT_ERR_MSG = `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`

export const CHECK_STATUS_PROJECT_ACTIVITY_ERR_MSG = `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`

export const SAVE_SUCCESS_MSG = `บันทึกสำเร็จ`
export const SAVE_DRAFT_MSG = `บันทึกร่าง`
export const SAVE_DRAFT_SUCCESS_MSG = `บันทึกร่างสำเร็จ`
export const SAVE_APPROVE_SUCCESS_MSG = `บันทึกผลการอนุมัติสำเร็จ`
export const PROCESS_SUCCESS_MSG = `ดำเนินการสำเร็จ`
export const DELETE_FILE_SUCCESS_MSG = `ลบไฟล์สำเร็จ`
export const DELETE_FILE_FAILED_MSG = `ลบไฟล์ไม่สำเร็จ`

export const PROCESS_ERR_MSG = `ดำเนินการไม่สำเร็จ ${RETRY_CONTACT_ADMIN}`

export const DELETE_SUCCESS_MSG = `ลบสำเร็จ`

export const SAVE_FAILED_MSG = `บันทึกไม่สำเร็จ`

export const ERR_MSG_CREATASSETCOUNT = `ไม่สามารถสร้างรายการใหม่ได้ ${RETRY_CONTACT_ADMIN}`
export const ERR_MSG_404 = `ไม่พบข้อมูล`
export const ERR_MSG_404_PROJECT_ID = `ไม่พบข้อมูล กรุณากลับไปหน้าหลัก`
export const ERR_MSG_404_TEMPLETE_ID = `ไม่พบข้อมูล กรุณากลับไปเลือก Templete ก่อน`

export const NOT_SPECIFIED_MSG = `- ไม่ระบุ -`
